import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../styles/layout/main.css';

const ActionBar = () => {
  const { t, i18n } = useTranslation('common');
  const navigate = useNavigate();

  const handleNewSubmission = (e) => {
    e.preventDefault();
    if (window.location.pathname === '/new-submission') {
      window.location.reload();
    } else {
      navigate('/new-submission');
    }
  };

  const handleSelectPackage = (e) => {
    e.preventDefault();
    navigate('/packages');
  };

  const handleAuthorServices = (e) => {
    e.preventDefault();
    navigate('/buy-author-service');
  };

  const [currentTime, setCurrentTime] = React.useState(new Date());

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const getFormattedDateTime = () => {
    try {
      const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      };
      return new Intl.DateTimeFormat(i18n.language || 'en', options).format(currentTime);
    } catch (e) {
      return currentTime.toLocaleString();
    }
  };

  return (
    <div className="esc-action-bar no-print">
      <a href="/new-submission" onClick={handleNewSubmission} className="btn-primary btn-gradient">
        <i className="material-icons">add</i>
        {t('new_submission', 'New Submission')}
      </a>

      <a
        href="/packages"
        onClick={handleSelectPackage}
        className="btn-secondary"
        style={{
          backgroundColor: '#009A49', // UAE flag green
          color: '#FFFFFF',
        }}
      >
        <i className="material-icons" style={{ color: '#FFFFFF' }}>add</i>
        {t('conference_tickets', 'Access Tickets')}
      </a>


      <a
        href="/buy-author-service"
        onClick={handleAuthorServices}
        className="btn-outline hide-mob"
        style={{
          backgroundColor: '#CE1126', // UAE flag red
          color: '#FFFFFF',
          borderColor: '#CE1126',
        }}
      >
        <i
          className="material-icons"
          style={{ color: '#FFFFFF' }}
        >
          add
        </i>
        {t('author_services', 'Author Services')}
      </a>


      <span className="deadline-pill ms-auto hide-mob" style={{ minWidth: '220px', justifyContent: 'center' }}>
        <i className="material-icons">access_time</i>
        {getFormattedDateTime()}
      </span>
    </div>
  );
};

export default ActionBar;